import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import ItemSellVarDetailFormContent from "./ItemSellVarDetailFormContent";
import {
  getOutletItemVariantDetail,
  saveOutletItemVariantDetail,
} from "../../../../../services/sales/outletService";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const itemVarDetailSchema = yup.object().shape({
  data: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      itemName: yup.string().required("Item Variant is required"),
      uomName: yup.string().required("Unit is required"),
      outletPrice: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Outlet Price is required")
        .moreThan(0, "Outlet Price cannot be zero or empty")
        .default(0),
    })
  ),
});
function ItemSellVarDetailForm({
  selectedItem = {
    ID: 0,
    outletID: 0,
    itemID: 0,
    item: { itemName: "", uomID: 0, itemUom: { uomName: "" } },
  },
  onConfirmSave,
  onCloseDialog,
}) {
  const { reload } = useGlobalData();
  const [itemVariants, setItemVariants] = useState([]);
  useEffect(() => {
    getItemVariantsData(selectedItem.outletID, selectedItem.itemID);
  }, [selectedItem, reload]);

  async function getItemVariantsData(outletID = 0, itemID = 0) {
    if (outletID > 0 && itemID > 0) {
      const response = await getOutletItemVariantDetail(outletID, itemID);
      const { data } = response.data;
      const { outletItemVariantDetail: itemVariantsTmp } = data;
      setItemVariants(itemVariantsTmp);
    }
  }
  return (
    <AppForm
      initialValues={{ data: itemVariants }}
      validationSchema={itemVarDetailSchema}
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title:
              "Are you sure want to save this Outlet Item Variant Prices ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveOutletItemVariantDetail(values.data).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <ItemSellVarDetailFormContent
        selectedItem={selectedItem}
        onCloseDialog={onCloseDialog}
      />
    </AppForm>
  );
}

export default ItemSellVarDetailForm;
